import React from 'react';
import { Link } from 'react-router-dom';

const variants = {
  primary: 'bg-foreground text-primary hover:bg-foreground/90',
  secondary: 'bg-transparent text-foreground border border-border-light hover:border-foreground',
  ghost: 'bg-transparent text-muted hover:text-foreground',
};

const sizes = {
  sm: 'px-4 py-2 text-small',
  md: 'px-6 py-3 text-body',
  lg: 'px-8 py-4 text-body-lg',
};

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  href,
  to,
  disabled,
  className = '',
  ...props
}) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-normal focus-visible:ring-2 focus-visible:ring-foreground focus-visible:ring-offset-2 focus-visible:ring-offset-primary disabled:opacity-50 disabled:cursor-not-allowed';
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;

  if (to) {
    return (
      <Link to={to} className={classes} {...props}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={classes} {...props}>
        {children}
      </a>
    );
  }

  return (
    <button className={classes} disabled={disabled} {...props}>
      {children}
    </button>
  );
}

export default Button;
